import React from 'react';

import PropTypes from 'prop-types';

import {
    PageSection,
    PageTitle,
} from 'wanderu-components';

import styles from './Header.scss';

function Header(props) {
    const {
        className,
        subtitle,
        title,
    } = props;

    return (
        <PageSection
            aria-labelledby="header-title"
            className={`${className} ${styles.header}`}
            layoutClassName={styles.layout}
        >
            <PageTitle
                className={styles.title}
                id="header-title"
            >
                {title}
            </PageTitle>
            <span className={styles.subtitle}>
                {subtitle}
            </span>
        </PageSection>
    );
}

Header.propTypes = {
    className: PropTypes.string,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
};
Header.defaultProps = {
    className: '',
};

export default Header;
